import Cookies from 'js-cookie';

// 过期时间（天）
const EXPIRESDAYS = 3;
const IN30MINUTES = 1 / 48;

export const getCookie = (key) => Cookies.get(key);

export const setCookie = (key, value) => Cookies.set(key, value, { expires: IN30MINUTES });

export const cookieSetUser = (token) => Cookies.set('vtoken', token, { expires: IN30MINUTES });

export const removeCookies = (key) => Cookies.remove(key);
